import { useState } from "react"

import { Divider, Flex, Switch, Typography } from "antd"
import { useTranslation } from "react-i18next"

import DropdownBlockCheckbox from "../../../../Components/Filters/DropdownBlockCheckbox"
import { NO_RESTRICTION } from "../../reducer"

import styles from "./FiltersBar.module.less"

const { Text } = Typography

/**
 * Three multi-selects and one toggle.
 *
 * Values within one filter combine as OR, different filters as AND. There is deliberately no
 * free-text search across the table — finding a value is done through the Current name filter and
 * the search field inside its own dropdown, which narrows the options rather than the table.
 */
const FiltersBar = ({ filters, filterOptions, onChangeFilter }) => {
  const { t } = useTranslation()
  // Only one dropdown is open at a time, so opening one closes the others.
  const [activeDropdownId, setActiveDropdownId] = useState(undefined)

  const multiSelects = [
    { id: "current_name", label: t("Current name"), data: filterOptions?.current_name },
    {
      id: "ui_name",
      label: t("UI name"),
      data: filterOptions?.ui_name,
      // An explicit option for rows with no UI name, so they can be targeted directly instead of
      // only through the Unmapped block.
      withNoOption: true,
      noOptionLabel: t("No UI name")
    },
    {
      id: "payment_processor",
      label: t("Payment processor"),
      data: filterOptions?.payment_processor
    }
  ]

  return (
    <>
      <Divider className={styles.divider} />

      <Flex align="center" gap={12} wrap="wrap" className={styles.bar}>
        {multiSelects.map(({ id, label, data, withNoOption, noOptionLabel }) => (
          <DropdownBlockCheckbox
            key={id}
            id={id}
            label={label}
            allBtnText={t("All")}
            withSearch
            data={data}
            dropdownFilters={filters?.[id] ?? NO_RESTRICTION}
            setDropdownFilters={onChangeFilter}
            withNoOption={withNoOption}
            noOptionLabel={noOptionLabel}
            activeDropdownId={activeDropdownId}
            showSelectedCount
            onOpenChange={(isOpen) => isOpen && setActiveDropdownId(id)}
          />
        ))}

        <Flex align="center" gap={8} className={styles.toggle}>
          <Switch
            size="small"
            checked={!!filters?.no_icon}
            onChange={(checked) => onChangeFilter({ no_icon: checked })}
            data-testid="payment-matching-no-icon-toggle"
          />
          <Text>{t("No icon")}</Text>
        </Flex>
      </Flex>
    </>
  )
}

export default FiltersBar
